import { render, staticRenderFns } from "./devTasks.vue?vue&type=template&id=0498d7d0&scoped=true"
import script from "./devTasks.vue?vue&type=script&lang=ts"
export * from "./devTasks.vue?vue&type=script&lang=ts"
import style0 from "./devTasks.vue?vue&type=style&index=0&id=0498d7d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0498d7d0",
  null
  
)

export default component.exports